import Flex from 'components/Flex'
import Row from 'components/Row.js'
import TextBodySmall from 'components/TextBodySmall'
import UserRow from 'components/UserRow'
import { View } from 'components/View'
import getValueReduxUtil from 'modules/redux/utils/get-value'
import React from 'react'

export default function AuthorRow ({ value }) {
  const bio = getValueReduxUtil(value, 'bio')
  const website = getValueReduxUtil(value, 'website')
  const avatar = getValueReduxUtil(value, 'avatar')
  return (
    <Row
      ac
      mt
    >
      <View pr>
        <UserRow.Avatar
          size={UserRow.Avatar.SIZE.BIGGER_1}
          value={avatar}
        />
      </View>
      <Flex
        jc
      >
        {!!bio && <TextBodySmall numberOfLines={4}>{bio}</TextBodySmall>}
        {!!website && (
          <UserRow.Website
            hasNoPadding
            value={website}
          />
        )}
      </Flex>
    </Row>
  )
}
